import { render, staticRenderFns } from "./RibbonButtonTwoState.vue?vue&type=template&id=88873aa6&scoped=true&"
import script from "./RibbonButtonTwoState.vue?vue&type=script&lang=js&"
export * from "./RibbonButtonTwoState.vue?vue&type=script&lang=js&"
import style0 from "./RibbonButtonTwoState.vue?vue&type=style&index=0&id=88873aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88873aa6",
  null
  
)

export default component.exports